"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Members = void 0;
const types_1 = require("@air/types");
const request_1 = require("./request");
const util_1 = require("./util");
/**
 * Returns an object with existing and pending workspace members
 */
function list({ workspaceId, options, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.members, {
        endpoint: `?${(0, util_1.stringifyOptions)(options || {})}`,
        workspaceId,
    });
}
/**
 * Add a list of members (with or without existing air accounts) with given roles
 * @param members List of new member information consisting of email and memberRole
 */
function add({ workspaceId, members, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.members, {
        method: 'POST',
        body: members,
        workspaceId,
    });
}
/**
 * Add a list of members (with or without existing air accounts) with given roles
 * @param members List of new member information consisting of email and memberRole
 */
function addByToken(_a) {
    return __awaiter(this, arguments, void 0, function* ({ userEmail, tokenValue, }) {
        yield (0, request_1.airRequest)(types_1.EndpointType.members, {
            method: 'POST',
            body: { userEmail, tokenValue },
        });
    });
}
/**
 * Updates roles for list of members
 * @param members List full members (given accountId) and/or pending members (given email)
 * with their updated memberRoles
 */
function update({ workspaceId, members, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.members, {
        method: 'PATCH',
        body: members,
        workspaceId,
    });
}
/**
 * Get a member's notification settings
 */
function getNotificationSettings({ workspaceId, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.members, {
        endpoint: 'settings/notifications',
        workspaceId,
    });
}
/**
 * Updates a member's notification settings
 */
function updateNotificationSettings({ workspaceId, updates, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.members, {
        method: 'PATCH',
        endpoint: 'settings/notifications',
        body: updates,
        workspaceId,
    });
}
/**
 * Marks full members as inactive, deletes pending members
 * @param members List of full members and/or pending members
 */
function remove({ workspaceId, members, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.members, {
        method: 'DELETE',
        body: members,
        workspaceId,
    });
}
function batchJoinApprovedWorkspaces(args) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.members, {
            method: 'POST',
            endpoint: `batch`,
            body: args,
        });
    });
}
exports.Members = {
    batchJoinApprovedWorkspaces,
    list,
    add,
    addByToken,
    update,
    getNotificationSettings,
    updateNotificationSettings,
    remove,
};
//# sourceMappingURL=member.js.map